// Merchant Info
export const FETCH_MERCHANT_INFO_REQUEST = 'reports/chatbot/FETCH_MERCHANT_INFO_REQUEST';
export const FETCH_MERCHANT_INFO_SUCCESS = 'reports/chatbot/FETCH_MERCHANT_INFO_SUCCESS';
export const FETCH_MERCHANT_INFO_FAILURE = 'reports/chatbot/FETCH_MERCHANT_INFO_FAILURE';

// Session
export const START_SESSION_REQUEST = 'reports/chatbot/START_SESSION_REQUEST';
export const START_SESSION_SUCCESS = 'reports/chatbot/START_SESSION_SUCCESS';
export const START_SESSION_FAILURE = 'reports/chatbot/START_SESSION_FAILURE';

// Chat History
export const FETCH_CHAT_HISTORY_REQUEST = 'reports/chatbot/FETCH_CHAT_HISTORY_REQUEST';
export const FETCH_CHAT_HISTORY_SUCCESS = 'reports/chatbot/FETCH_CHAT_HISTORY_SUCCESS';
export const FETCH_CHAT_HISTORY_FAILURE = 'reports/chatbot/FETCH_CHAT_HISTORY_FAILURE';

// Query flow: classify → metrics? → insights
export const SEND_QUERY_REQUEST = 'reports/chatbot/SEND_QUERY_REQUEST';
export const CLASSIFY_LOADING_SET = 'reports/chatbot/CLASSIFY_LOADING_SET';
export const METRICS_LOADING_SET = 'reports/chatbot/METRICS_LOADING_SET';
export const INSIGHTS_LOADING_SET = 'reports/chatbot/INSIGHTS_LOADING_SET';

// Retry
export const RETRY_DATA_REQUEST = 'reports/chatbot/RETRY_DATA_REQUEST';
export const RETRY_INSIGHTS_REQUEST = 'reports/chatbot/RETRY_INSIGHTS_REQUEST';

// Cancel in-flight query
export const CANCEL_QUERY_REQUEST = 'reports/chatbot/CANCEL_QUERY_REQUEST';

// Conversation mutations
export const CHATBOT_ADD_MESSAGE = 'reports/chatbot/CHATBOT_ADD_MESSAGE';
export const CHATBOT_UPDATE_MESSAGE = 'reports/chatbot/CHATBOT_UPDATE_MESSAGE';
export const CHATBOT_RESET_CONVERSATION = 'reports/chatbot/CHATBOT_RESET_CONVERSATION';
export const CHATBOT_CANCEL_LOADING_MESSAGES = 'reports/chatbot/CHATBOT_CANCEL_LOADING_MESSAGES';
